// Version : 0.0.1
// Author :AGALYA

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** GET AUDITING TOOL LIST START *********************** */
export const auditingToolListGet = (listData: any) => {
	const data = {
		GetTrainingProposalListToken: listData,
	};
	const url = `${API_URL}getTrainingProposalList`;
	return makeApiCall(url, data);
};
/** ***************** GET AUDITING TOOL LIST END *********************** */

/** ***************** FETCH AUDITING TOOL LIST START *********************** */
export const auditingToolGet = (listData: any) => {
	const data = {
		GetTrainingProposalDetailsToken: listData,
	};
	const url = `${API_URL}fetchTrainingDetails`;
	return makeApiCall(url, data);
};
/** ***************** FETCH AUDITING TOOL LIST END *********************** */

/** ***************** GET QUESTIONNAIRE START *********************** */
export const questionnaireAllGet = (listData: any) => {
	const data = {
		GetAllQuestionnaireListToken: listData,
	};
	const url = `${API_URL}getAllquestionnaireList`;
	return makeApiCall(url, data);
};
/** ***************** GET QUESTIONNAIRE END *********************** */

/** ***************** GET TRAINING PROPOSAL MEMBERS START *********************** */
export const trainingProposalMembersList = (listData: any) => {
	const data = {
		GetAllTrainingMembersToken: listData,
	};
	const url = `${API_URL}getTrainingProposalMembers`;
	return makeApiCall(url, data);
};
/** ***************** GET TRAINING PROPOSAL MEMBERS END *********************** */

/** ***************** GET TRAINING PROPOSAL INDIVIDUAL START *********************** */
export const trainingProposalIndividualList = (listData: any) => {
	const data = {
		GetAllTrainingIndividualToken: listData,
	};
	const url = `${API_URL}getTrainingProposalIndividual`;
	return makeApiCall(url, data);
};
/** ***************** GET TRAINING PROPOSAL INDIVIDUAL END *********************** */

/** ***************** ADD TRAINING PROPOSAL START *********************** */
export const addtrainingProposalList = (listData: any) => {
	const data = {
		NewGroupTrainingProposalToken: listData,
	};
	const url = `${API_URL}createGroupTrainingProposal`;
	return makeApiCall(url, data);
};
/** ***************** ADD TRAINING PROPOSAL END *********************** */

/** ***************** UPDATE TRAINING PROPOSAL START *********************** */
export const updatetrainingProposalList = (listData: any) => {
	const data = {
		UpdateGroupTrainingProposalToken: listData,
	};
	const url = `${API_URL}updateGroupTrainingProposal`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE TRAINING PROPOSAL END *********************** */

/** ***************** DELETE TRAINING PROPOSAL START *********************** */
export const deleteTrainingProposalList = (listData: any) => {
	const data = {
		DeleteGroupTrainingProposalToken: listData,
	};
	const url = `${API_URL}deleteGroupTrainingProposal`;
	return makeApiCall(url, data);
};
/** ***************** DELETE TRAINING PROPOSAL END *********************** */

/** ***************** GET SUPERVISER LIST START *********************** */
export const getAllSuperviserList = (listData: any) => {
	const data = {
		GetAllSuperviserListToken: listData,
	};
	const url = `${API_URL}getAllSuperviserList`;
	return makeApiCall(url, data);
};
/** ***************** GET SUPERVISER LIST END *********************** */

/** ***************** APPROVE TRAINING PROPOSAL START *********************** */
export const approveTrainingProposalList = (listData: any) => {
	const data = {
		UpdateTraningProposalStatusToken: listData,
	};
	const url = `${API_URL}approveTrainingProposalList`;
	return makeApiCall(url, data);
};
/** ***************** APPROVE TRAINING PROPOSAL END *********************** */

/** ***************** SAVE PHYSICAL DOCS START *********************** */
export const savePhysicalDocsForMember = (listData: any) => {
	const data = {
		PhysicalDocsForMemberToken: listData,
	};
	const url = `${API_URL}savePhysicalDocsOfMemberForAuditTool`;
	return makeApiCall(url, data);
};
/** ***************** SAVE PHYSICAL DOCS END *********************** */

/** ***************** SAVE DIGITAL DOCS START *********************** */
export const saveDigitalDocsForMember = (listData: any) => {
	const data = {
		DigitalDocsForMemberToken: listData,
	};
	const url = `${API_URL}saveDigitalDocsOfMemberForAuditTool`;
	return makeApiCall(url, data);
};
/** ***************** SAVE DIGITAL DOCS END *********************** */

/** ***************** RE-AUDIT PROPOSAL START *********************** */
export const reAuditProposal = (listData: any) => {
	const data = {
		TrainingReAuditingToken: listData,
	};
	const url = `${API_URL}reAuditProposal`;
	return makeApiCall(url, data);
};
/** ***************** RE-AUDIT PROPOSAL END *********************** */

/** ***************** GET MEMBER AUDIT ANSWERS START *********************** */
export const getMemberAuditAnswers = (listData: any) => {
	const data = {
		MemberAuditFetchApproveToken: listData,
	};
	const url = `${API_URL}getMemberAuditAnswersForApprove`;
	return makeApiCall(url, data);
};
/** ***************** GET MEMBER AUDIT ANSWERS END *********************** */
